module.exports = __webpack_public_path__ + "static/media/LivingRoom.881bce29.glb";